import React from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import classNames from "classnames";

import { INavLinkType } from "../types/shared";

const Footer = (): React.JSX.Element => {
    const footerLinks: INavLinkType[] = [
        {
            title: "Wisconsin Baseball Tournaments",
            location: "https://www.wisconsinbaseballtournaments.com/",
        },
        {
            title: "Tournament Rules",
            location: "/rules",
        },
    ];

    return (
        <div id="footerWrapper" className={classNames("noPrint")}>
            <Container fluid="lg" className="footer" data-testid="footer">
                <h3>Have questions? Don't hesitate to contact us!</h3>
                <Row>
                    <Col className="d-flex d-lg-block">
                        <NavLink to="/contact-us" className="contactButton">
                            Contact Us
                        </NavLink>
                    </Col>
                </Row>
                <Nav>
                    <Nav.Item>
                        <p className="nav-link">
                            &copy; {new Date().getFullYear()} Baseball365 Inc.
                        </p>
                    </Nav.Item>

                    {footerLinks.map((link: INavLinkType) => (
                        <Nav.Item key={link.title}>
                            <NavLink to={link.location} className="nav-link">
                                {link.title}
                            </NavLink>
                        </Nav.Item>
                    ))}
                </Nav>
            </Container>
        </div>
    );
};

export default Footer;
